<section class="business_profile" >
    <div class="bus_profile_card">
        <div class="row">
            <div class="col-sm-12">
        <div class="welcome_heading">
            <h3>Employee profile</h3>
         </div>
        </div>
      
    </div>

<div class="row">
    <div class="chip_services_list">
        <mat-chip-list>
          <mat-chip [ngClass]="{'selected': selectedValue == 1}" (click)="selectChip(1)"> Current Employer </mat-chip>
            <mat-chip [ngClass]="{'selected': selectedValue == 2}" (click)="selectChip(2)">Ex-Employer </mat-chip>
            <mat-chip [ngClass]="{'selected': selectedValue == 3}" (click)="selectChip(3)">Job invitations </mat-chip>
        </mat-chip-list>
    </div>
    <div class="row" *ngIf="(selectedValue == 1 || selectedValue == 2) && employerData.length > 0 && !isloader">
        <div class="col-sm-3" *ngFor="let item of employerData">
            <div class="salon_mei_sectionx ">
                <mat-card (click)="openBusinessDetails(item)">
                   <div class="exert_opd">
                    <div class="active_busn" *ngIf="item.business_status == 0 || !item.subscriptionInfo || item.subscriptionInfo == 'null'">
                    
                </div>
                <div class="active_send" *ngIf="item.business_status == 1 && item.subscriptionInfo && item.subscriptionInfo != 'null'">
                    
                </div>
                    <!-- <div class="active_send" *ngIf="item.isActive == 1">
                    </div> -->
                <div class="salon_img">
                    <img *ngIf="item.entityInfo.revenue_model ==1" [src]="item.entityInfo.default_image?.image_thumb_url" onerror="this.src='../../../../assets/images/entity_placeholder.png'"  alt="">
                    <img *ngIf="item.entityInfo.revenue_model ==2" [src]="item.entityInfo.default_image?.image_thumb_url" onerror="this.src='../../../../assets/images/fitness-placeholder.png'"  alt="">
                </div>
                <div class="hair_ct_heading">
                    <h4  style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{item.entityInfo.entityName}}</h4>
                    <p style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;">  Service: {{item.entity_services | servToStr}}</p>
                    <p style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;">  {{item.entityInfo.addressLine}} 
                    </p>
                    <p>{{item.entityInfo.entity_country_code}} {{item.entityInfo.entityPhone}}</p>
                </div>
              <div class="desc_box">
                    <p *ngIf="selectedValue == 1">Joined on: {{item.date_of_join ? (item.date_of_join |  date) : '---'}}</p>
                    <p *ngIf="selectedValue == 2">Exited on: {{item.date_of_exit ? (item.date_of_exit |  date) : '---'}}</p>
                </div>
             </div>
             <div class="onhover_arrow" *ngIf="selectedValue == 1">
                <mat-icon class="hover-icon"> arrow_forward</mat-icon>
           </div>
            </mat-card>
            </div>
           </div>

    </div>
    <div class="row" *ngIf="(selectedValue == 3) && joiningInvitationsList.length > 0 && !isloader">
        
            <div class="col-sm-3" *ngFor="let item of joiningInvitationsList">
              <div class="serv_sect">
                <!-- (click)="viewInvitationDetails(item.requestHashId)" -->
                <mat-card class="service-card"  (click)="openInvitationsDetails(item)">
                  <div class="hy_secf">
                    <div class="salon_img">
                        <img *ngIf="item.entityInfo.revenue_model ==1" [src]="item.entityInfo.default_thumb_image" onerror="this.src='../../../../assets/images/entity_placeholder.png'"  alt="">
                        <img *ngIf="item.entityInfo.revenue_model ==2" [src]="item.entityInfo.default_thumb_image" onerror="this.src='../../../../assets/images/fitness-placeholder.png'"  alt="">
                    </div>
                    <!-- <button
                      mat-icon-button
                      [matMenuTriggerFor]="menu2"
                      class="more-button"
                      aria-label="More options"
                      *ngIf="selectedValue != 2"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu2="matMenu">
                      <button
                        mat-menu-item
                        (click)="viewInvitationDetails(item.requestHashId)"
                      >
                        <mat-icon class="material-icons-outlined">info</mat-icon>
                        <span>View details</span>
                      </button>
                   
                    </mat-menu> -->
                  </div>
                  <mat-card-content>
                    <div class="header_ftgt">
                      <h4>{{item.entityInfo.name}}</h4>
                      <mat-card-subtitle
                        >{{item.entityInfo.country_code}} {{item.entityInfo.phone}}</mat-card-subtitle
                      >
                    </div>
                    <div class="location_list_s">
                      <div class="new_empol">
                        <p>
                          <mat-icon>payments</mat-icon> {{item.entityInfo.currency_symbol}}{{ item.joiningSalary }}
                        </p>
                      </div>
                      <div class="new_empol">
                        <p>
                          <mat-icon style="color: #434343">calendar_month</mat-icon>
                          {{ item.creationDate | date }} 
                        </p>
                      </div>
                    </div>
                    <!-- <div class="chuo_list">
                      <div class="send_messages_btn">
                          <h3 (click)="openMessages(item,$event)">Send messages</h3>
                      </div>
                      <div class="onhover_arrow">
                          <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                     </div>
                  </div> -->
                  </mat-card-content>
                </mat-card>
              </div>
            </div>

    </div>


    <!-- placeholder start -->

    <!-- placeholder end -->


     
</div>
</div>

  <div class="placeholder_started" *ngIf="!isloader && employerData.length == 0 && joiningInvitationsList.length == 0">
  
        <div class="row">
       
          <div class="col-sm-4" *ngIf="selectedValue == 1">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/current-employer-placeholder.png">
                 </div>
                 <mat-card-title>No active employer</mat-card-title>
                 <mat-card-content>You haven't yet joined any business as a team member or employee. Check the 'Job invitation' tab for the new joining request. 
                </mat-card-content>
                 <!-- <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div> -->
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4" *ngIf="selectedValue == 2">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/ex-employer-placeholder.png">
                 </div>
                 <mat-card-title>No ex-employer data</mat-card-title>
                 <mat-card-content>There's no information of any business where you worked previously. You can check 'Job invitation' tab for new joining request.
                </mat-card-content>
                 <!-- <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div> -->
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4" *ngIf="selectedValue == 3">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/joining-invitation.png">
                 </div>
                 <mat-card-title>No joining request to show</mat-card-title>
                 <mat-card-content>It seems no business yet sent you any invitation to join their team or business. Cross check whether the invitation sent to the same phone number you logged in. 
                </mat-card-content>
                 <!-- <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div> -->
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in getting the employer data or in issues with invitation, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
      </div> 
</section>